import * as RadixSwitch from '@radix-ui/react-switch';
import type { ReactNode } from 'react';

import { cn } from './cn';

/**
 * Перемикач для станів, які вмикаються негайно.
 *
 * Відрізняється від прапорця за змістом: прапорець — вибір у наборі, який
 * застосують потім; перемикач діє одразу. Тому фільтри «показувати лише…»
 * саме перемикачі, а список марок — прапорці.
 */
export function Switch({
	checked,
	onCheckedChange,
	ariaLabel,
	className,
}: {
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
	ariaLabel?: string;
	className?: string;
}): ReactNode {
	return (
		<RadixSwitch.Root
			checked={checked}
			onCheckedChange={onCheckedChange}
			aria-label={ariaLabel}
			className={cn(
				'relative h-5 w-9 shrink-0 rounded-full border transition-colors',
				'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40',
				checked ? 'border-primary-solid bg-primary-solid' : 'border-border-strong bg-surface-muted',
				className,
			)}
		>
			<RadixSwitch.Thumb
				className={cn(
					'block size-3.5 rounded-full bg-surface shadow-e1 transition-transform',
					'translate-x-[3px] data-[state=checked]:translate-x-[19px]',
					checked && 'bg-primary-fg',
				)}
			/>
		</RadixSwitch.Root>
	);
}
